module.exports = __webpack_public_path__ + "static/media/skill7_neg_en.c69456bc.txt";